// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, put } from "./api_client";
import { DeviceErrorSortKey, ErrorIssueStatus, ServerErrorSortKey } from "../models";
import { ErrorSummary, IErrorSummary, DeviceErrorPaginatedResult, IDeviceErrorPaginatedResult, ErrorTrendResult, IErrorTrendResult, FirmwareErrorStat, IFirmwareErrorStat, ErrorDetails, IErrorDetails, ServerErrorSummary, IServerErrorSummary, ServerErrorPaginatedResult, IServerErrorPaginatedResult, ErrorIssueUpdateRequest, IErrorIssueUpdateRequest } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function getAllDeviceErrors(): ApiResult<ErrorSummary[]> {
	return get<IErrorSummary[]>(`/api/error/device`).then(result => result === undefined ? undefined : result.map(o => new ErrorSummary(o)));
}

export async function getAllDeviceErrorsPaginated(page: number, pageSize: number, sortKey?: DeviceErrorSortKey, sortDirection?: string, detailsId?: string, search?: string, deviceId?: string, dateFrom?: Date, dateTo?: Date, status?: ErrorIssueStatus, hideIgnored?: boolean, onlyLatestFirmware?: boolean): ApiResult<DeviceErrorPaginatedResult> {
		const queryParams = [page !== undefined ? `page=${page}` : undefined,
			pageSize !== undefined ? `pageSize=${pageSize}` : undefined,
			sortKey !== undefined ? `sortKey=${sortKey}` : undefined,
			sortDirection !== undefined ? `sortDirection=${sortDirection}` : undefined,
			detailsId !== undefined ? `detailsId=${detailsId}` : undefined,
			search !== undefined ? `search=${search}` : undefined,
			deviceId !== undefined ? `deviceId=${deviceId}` : undefined,
			dateFrom !== undefined ? `dateFrom=${dateFrom.toISOString()}` : undefined,
			dateTo !== undefined ? `dateTo=${dateTo.toISOString()}` : undefined,
			status !== undefined ? `status=${status}` : undefined,
			hideIgnored !== undefined ? `hideIgnored=${hideIgnored}` : undefined,
			onlyLatestFirmware !== undefined ? `onlyLatestFirmware=${onlyLatestFirmware}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IDeviceErrorPaginatedResult>(`/api/error/device_paginated${query}`).then(result => result === undefined ? undefined :  new DeviceErrorPaginatedResult(result));
}

export async function getDeviceErrors(id?: string): ApiResult<ErrorSummary[]> {
	return get<IErrorSummary[]>(`/api/error/device/${ id }`).then(result => result === undefined ? undefined : result.map(o => new ErrorSummary(o)));
}

export async function getDeviceErrorsPaginated(id?: string, page?: number, pageSize?: number, sortKey?: DeviceErrorSortKey, sortDirection?: string, detailsId?: string, search?: string, dateFrom?: Date, dateTo?: Date, status?: ErrorIssueStatus, hideIgnored?: boolean, onlyLatestFirmware?: boolean): ApiResult<DeviceErrorPaginatedResult> {
		const queryParams = [page !== undefined ? `page=${page}` : undefined,
			pageSize !== undefined ? `pageSize=${pageSize}` : undefined,
			sortKey !== undefined ? `sortKey=${sortKey}` : undefined,
			sortDirection !== undefined ? `sortDirection=${sortDirection}` : undefined,
			detailsId !== undefined ? `detailsId=${detailsId}` : undefined,
			search !== undefined ? `search=${search}` : undefined,
			dateFrom !== undefined ? `dateFrom=${dateFrom.toISOString()}` : undefined,
			dateTo !== undefined ? `dateTo=${dateTo.toISOString()}` : undefined,
			status !== undefined ? `status=${status}` : undefined,
			hideIgnored !== undefined ? `hideIgnored=${hideIgnored}` : undefined,
			onlyLatestFirmware !== undefined ? `onlyLatestFirmware=${onlyLatestFirmware}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IDeviceErrorPaginatedResult>(`/api/error/device_paginated/${ id }${query}`).then(result => result === undefined ? undefined :  new DeviceErrorPaginatedResult(result));
}

export async function getDeviceErrorTrend(): ApiResult<ErrorTrendResult> {
	return get<IErrorTrendResult>(`/api/error/device_trend`).then(result => result === undefined ? undefined :  new ErrorTrendResult(result));
}

export async function getDeviceErrorTrendForDevice(id?: string): ApiResult<ErrorTrendResult> {
	return get<IErrorTrendResult>(`/api/error/device_trend/${ id }`).then(result => result === undefined ? undefined :  new ErrorTrendResult(result));
}

export async function getFirmwareErrorScatter(hideIgnored: boolean): ApiResult<FirmwareErrorStat[]> {
		const queryParams = [hideIgnored !== undefined ? `hideIgnored=${hideIgnored}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IFirmwareErrorStat[]>(`/api/error/device/firmware_scatter${query}`).then(result => result === undefined ? undefined : result.map(o => new FirmwareErrorStat(o)));
}

export async function updateDeviceErrorIssue(hashId?: string, request?: ErrorIssueUpdateRequest): ApiResult<ErrorDetails> {
	return put<IErrorDetails>(`/api/error/device/issue/${ hashId }`, request).then(result => result === undefined ? undefined :  new ErrorDetails(result));
}

export async function getServerErrors(page: number, pageSize: number): ApiResult<ServerErrorSummary[]> {
		const queryParams = [page !== undefined ? `page=${page}` : undefined,
			pageSize !== undefined ? `pageSize=${pageSize}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IServerErrorSummary[]>(`/api/error/server${query}`).then(result => result === undefined ? undefined : result.map(o => new ServerErrorSummary(o)));
}

export async function getServerErrorsPaginated(page: number, pageSize: number, sortKey?: ServerErrorSortKey, sortDirection?: string, traceId?: string, dateFrom?: Date, dateTo?: Date): ApiResult<ServerErrorPaginatedResult> {
		const queryParams = [page !== undefined ? `page=${page}` : undefined,
			pageSize !== undefined ? `pageSize=${pageSize}` : undefined,
			sortKey !== undefined ? `sortKey=${sortKey}` : undefined,
			sortDirection !== undefined ? `sortDirection=${sortDirection}` : undefined,
			traceId !== undefined ? `traceId=${traceId}` : undefined,
			dateFrom !== undefined ? `dateFrom=${dateFrom.toISOString()}` : undefined,
			dateTo !== undefined ? `dateTo=${dateTo.toISOString()}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IServerErrorPaginatedResult>(`/api/error/server_paginated${query}`).then(result => result === undefined ? undefined :  new ServerErrorPaginatedResult(result));
}
